// extracted by mini-css-extract-plugin
export default {"course":"Course_course__VUXbX","mark":"Course_mark__yrBuz","progress":"Course_progress__XtQ-M"};